import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function usePreviousPath() {
  const location = useLocation();
  const prevPathRef = useRef();

  // 현재 값을 이전 값으로 저장
  const currentPath = location.pathname;
  const previousPath = prevPathRef.current;

  useEffect(() => {
    if (currentPath !== previousPath) {
    prevPathRef.current = currentPath;
    }
  }, [currentPath, previousPath]);

  return previousPath; // 이전 값 반환
}
